












































import { Component, Vue } from 'vue-property-decorator';
import Panel from '@/components/Panel.vue';

@Component({
  components: {
    Panel,
  },
})
export default class About extends Vue {}
